import { Box, Button, Dialog, DialogContent, Divider, TextField, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { pettyCashApiNm, pettyCashColNm } from "./constant"
import { pcItemAddTableColumns } from "./columns"
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { bahtProps } from "utils/bahtProps"
import { blueGrey, green, red } from "@mui/material/colors"
import { AddCircleRounded } from "resource/muiImport"
import ComboBox from "components/ComboBox"
import { numberFormat } from "utils"
import dayjs from "dayjs"
import { UserContext } from "contexts/UserContext"
import { alertError } from "components/Alert"

let selectedRowId = null
const AddItemTableDialog = ({ pcTrnsData, JobOrdIds, dialogOpen, setDialogOpen, onFinish, updLnkSiteAbbr }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)
  const [usrAccId, setUsrAccId] = useState(null)
  const [pcJnlId, setPcJnlId] = useState(null)
  const [dataTable, setDataTable] = useState([])
  const [expId, setExpId] = useState(null)

  const textFieldProps = useCallback((name) => ({
    size: 'small',
    value: pcTrnsData[name] || "",
    label: pettyCashColNm[name]
  }), [pcTrnsData])

  const modDataTable = useMemo(() => {
    // let sum = 0;
    // for (const row of dataTable) {
    //   sum += row.PayAmnt
    // }
    // return [...dataTable, {
    //   id: 0,
    //   ExpNm: "รวม",
    //   PayAmnt: sum
    // }]
    return addSumRow({
      dataTable: dataTable,
      sumColNms: ["Amnt", "PayAmnt"],
      sumColTotal: "ExpNm"
    })
  }, [dataTable])

  const favExp = useMemo(() => {
    return msData.expOprCombo.filter(item => item.isFav)
  }, [msData.expOprCombo])

  const nonFavExp = useMemo(() => {
    return msData.expOprCombo.filter(item => !item.isFav)
  }, [msData.expOprCombo])

  const diffAmnt = useMemo(() => {
    if (!pcTrnsData.PCTrnsId) return 0
    return +pcTrnsData.PayAmnt - dataTable.reduce((acc, row) => {
      const { Amnt, VatPrct, WhtPrct } = row
      return acc + (((Amnt / (1 + (VatPrct / 100))) * (1 - (WhtPrct / 100)))
        + (((Amnt / (1 + (VatPrct / 100))) * VatPrct) / 100))
    }, 0)

  }, [pcTrnsData, dataTable])

  const setExpAmnt = useCallback((id, jobOrdId) => {
    setDataTable(o => {
      const result = [...o]
      const foundIndex = result.findIndex(r => r.id === id)
      result[foundIndex].IsLoading = true
      return result
    })
    ax.post(pettyCashApiNm.getJobOrderLocation, { JobOrdId: jobOrdId, UpdLnkSiteAbbr: updLnkSiteAbbr }, false).then(value => {
      if (value.data) {
        setDataTable(o => {
          const result = [...o]
          const foundIndex = result.findIndex(r => r.id === id)

          if (value.data.length !== 1) {
            alertError("ไม่พบข้อมูล เลขที่ใบงานนี้")
            result[foundIndex] = {
              ...result[foundIndex],
              JobOrdId: null,
              Loc: "",
            }
          } else {
            const data = value.data[0]
            result[foundIndex] = {
              ...result[foundIndex],
              JobOrdId: data.JobOrdId,
              Loc: `${data.TakePlc || ""}-${data.Loc || ""}-${data.RtnPlc || ""}`,
            }
          }
          result[foundIndex].IsLoading = false
          return result
        })

      }
    })

  }, [ax, updLnkSiteAbbr])
  const handleEditCommit = useCallback((params) => {


    if (params.field === "JobOrdId") {
      setExpAmnt(params.id, params.value)

    } else {

      if (params.field === "DocNo" && params.value) {
        ax.post(pettyCashApiNm.checkDocNoExist, { DocNo: params.value }, false).then(value => {
          if (value.data) {
            if (value.data.length > 0) {
              alertError(`เลขที่เอกสาร ${params.value} มีอยู่ในระบบแล้ว กรุณาตรวจสอบ`)
            }
          }
        })
      }
      setDataTable(o => {
        const result = [...o]
        const foundIndex = result.findIndex(r => r.id === params.id)
        if (foundIndex === -1) {
          return result
        }
        result[foundIndex][params.field] = params.value
        const { Amnt, VatPrct, WhtPrct } = result[foundIndex]
        let amnt = Amnt
        let amntB4Vat = amnt / (1 + (VatPrct / 100))
        if (params.field === "Amnt") {
          amnt = params.value
          amntB4Vat = amnt / (1 + (VatPrct / 100))
        } else if (params.field === "AmntB4Vat") {
          amntB4Vat = params.value
          amnt = amntB4Vat * (1 + (VatPrct / 100))
        } else if (params.field === "VatPrct") {
          amnt = Amnt
          amntB4Vat = amnt / (1 + (VatPrct / 100))
        }
        result[foundIndex] = {
          ...result[foundIndex], [params.field]: params.value,
          Amnt: amnt,
          AmntB4Vat: amntB4Vat,
          PayAmnt: (((amnt / (1 + (VatPrct / 100))) * (1 - (WhtPrct / 100)))
            + (((amnt / (1 + (VatPrct / 100))) * VatPrct) / 100))
        }
        // const rowId0 = result.find(row => row.id === 0)
        // if(row)
        // rowId0.PayAmnt = result.reduce((acc, row) => acc + +row.PayAmnt, 0)
        return result
      })
    }
  }, [setExpAmnt, ax])

  const handleAddExp = useCallback((expObj) => {

    setDataTable(o => {
      const result = [...o]
      let found = msData.expensePOIs.find(exp => (!exp.ExpId || exp.ExpId === expObj.id)
        && (!exp.JobId || exp.JobId === pcTrnsData.JobId)
        && (!exp.POIId || [pcTrnsData.TakePOIId, pcTrnsData.LocPOIId, pcTrnsData.RtnPOIId].includes(exp.POIId))
        && (!exp.ContSize || exp.ContSize === pcTrnsData.ContSize)
        && (!exp.ContType || exp.ContType === pcTrnsData.ContType)
        && (!exp.ShpmTypId || exp.ShpmTypId === pcTrnsData.ShpmTypId)
        && (!exp.TlrTypId || exp.TlrTypId === pcTrnsData.TlrTypId)
      )

      if (!found) {
        found = msData.expObj[expObj.id]
      }
      const amnt = +(found.UntPr || 0)
      const vatPrct = +(found.VatPrct || 0)
      const whtPrct = +(found.WhtPrct || 0)
      const newRow = {
        id: result.length + 1,
        No: result.length + 1,
        IsCost: found.IsCost || 0,
        IsOwnRcpt: found.IsOwnRcpt || 0,
        ExpId: expObj.id,
        ExpNm: expObj.label,
        Dscp: "",
        DocNo: "",
        Rmk: "",
        JobOrdId: pcTrnsData.JobOrdId,
        Loc: `${pcTrnsData.TakePlc || ""}-${pcTrnsData.Loc || ""}-${pcTrnsData.RtnPlc || ""}`,
        TakePOIId: pcTrnsData.TakePOIId,
        LocPOIId: pcTrnsData.LocPOIId,
        RtnPOIId: pcTrnsData.RtnPOIId,
        InOutTyp: pcTrnsData.InOutTyp,
        DocDte: null,
        Amnt: amnt,
        AmntB4Vat: (amnt / (1 + (vatPrct / 100))),
        VatPrct: vatPrct,
        WhtPrct: whtPrct,
        PayAmnt: (((amnt / (1 + (vatPrct / 100))) * (1 - (whtPrct / 100)))
          + (((amnt / (1 + (vatPrct / 100))) * vatPrct) / 100)),
        // PCJnlId: msData.pcJournalCombo.find(jnl => jnl.IsDf)?.id,
        IsLoading: false,
      }
      result.push(newRow)
      return result
    })
  }, [msData.expensePOIs, pcTrnsData, msData.expObj])

  const handleAddFromCombo = useCallback(() => {
    if (expId) {
      const expObj = msData.expOprCombo.find(exp => exp.id === expId)
      handleAddExp(expObj)
    }
  }, [msData.expOprCombo, expId, handleAddExp])

  const handleRemoveRow = useCallback((row) => {
    setDataTable(o => o.filter(r => r.id !== row.id))
  }, [])

  const handleChangeIsCost = useCallback((id, colName) => {

    setDataTable(o => {
      const result = [...o]
      const foundIndex = result.findIndex(r => r.id === id)
      result[foundIndex] = { ...result[foundIndex], [colName]: result[foundIndex][colName] === 0 ? 1 : 0 }
      return result
    })
  }, [])


  const handleDialogOk = useCallback(() => {


    if (dataTable.length === 0) {
      alertError("กรุณาเพิ่มข้อมูล การใช้เงิน")
      return
    }
    if (pcTrnsData.PCTrnsId) {
      const postData = {
        argsArr: dataTable.map(row => ({
          ...row,
          InOutTypItm: row.InOutTyp,
          PCTrnsId: pcTrnsData.PCTrnsId,
          PCItmTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          AdmAccId: user.AccId,
        })),
        getFn: "getPettyCashDetail",
        PCTrnsId: pcTrnsData.PCTrnsId,
        UpdLnkSiteAbbr: updLnkSiteAbbr,
      }
      ax.post(pettyCashApiNm.insertPCItemBulk, postData).then(value => {
        if (value.data) {
          onFinish(value.data)
          setDialogOpen(false)
        }
      })
    } else {
      if (!usrAccId) {
        alertError("กรุณาเลือก ผู้ใช้เงิน ก่อน")
        return
      }
      if (!pcJnlId) {
        alertError("กรุณาเลือก สมุดบัญชี ก่อน")
        return
      }
      const postData = {
        argsArr: dataTable.map(row => ({
          ...row,
          PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          AdmAccId: user.AccId,
          UsrAccId: usrAccId,
          PCJnlId: pcJnlId,
          InOutTyp: "O",
          IsReim: 1,
          IsCmpt: 1,
          UpdLnkSiteAbbr: updLnkSiteAbbr,
        })),
        getFn: null,
      }
      if (!JobOrdIds) {
        ax.post(pettyCashApiNm.insertPCTransactionBulk, postData).then(value => {
          if (value.data) {
            onFinish(null)
            setDialogOpen(false)
          }
        })
      } else {
        const newArgsArr = []
        for (const joOrdId of JobOrdIds) {
          for (const args of postData.argsArr) {
            args.JobOrdId = joOrdId
            newArgsArr.push(args)
          }
        }
        postData.argsArr = newArgsArr
        ax.post(pettyCashApiNm.insertPCTransactionBulk, postData).then(value => {
          if (value.data) {
            onFinish(null)
            setDialogOpen(false)
          }
        })
      }
    }

  }, [ax, dataTable, pcTrnsData, user.AccId, onFinish, setDialogOpen, usrAccId, pcJnlId
    , JobOrdIds, updLnkSiteAbbr])

  /**
   * Had to has pcjnl columns in the table but move it to the top of table 
   * So dont use this function any more 
   */
  // const handlePCJournalIdChnage = useCallback((id, value) => {
  //   setDataTable(o => {
  //     const result = [...o]
  //     const foundIndex = result.findIndex(r => r.id === id)
  //     result[foundIndex].PCJnlId = value
  //     return result
  //   })
  // }, [])

  const handleSelectJobOrder = useCallback((item) => {
    if (!selectedRowId) {
      return
    }

    setDataTable(o => {
      const result = [...o]
      const foundIndex = result.findIndex(r => r.id === selectedRowId)
      if (foundIndex !== -1) {
        result[foundIndex].JobOrdId = item.JobOrdId
        result[foundIndex].Loc = `${item.TakePlc || ""}-${item.Loc || ""}-${item.RtnPlc || ""}`
      }
      return result
    })
    setExpAmnt(selectedRowId, item.JobOrdId)
  }, [setExpAmnt])

  const handlePopoverSearchOpen = useCallback((id) => () => {
    selectedRowId = id
  }, [])

  const pcItemAddTableColumnsMemo = useMemo(() => {
    return pcItemAddTableColumns({
      handleChangeIsCost, handleRemoveRow, handlePopoverSearchOpen, handleSelectJobOrder
      , suggestDrvId: pcTrnsData.UsrAccId
    })
  }, [handleChangeIsCost, handleRemoveRow, handleSelectJobOrder, handlePopoverSearchOpen, pcTrnsData.UsrAccId])

  useEffect(() => {

    if (!dialogOpen) {
      setDataTable([])
      setExpId(null)
    } else {
      if (!pcTrnsData.PCTrnsId) {
        setUsrAccId(pcTrnsData.DrvId || user.AccId)
        setPcJnlId(msData.pcJournalCombo.find(jnl => jnl.IsDf)?.id)
      }
    }
  }, [dialogOpen, pcTrnsData.DrvId, pcTrnsData.PCTrnsId, msData.pcJournalCombo, user.AccId])

  // console.log("PcTrnsData::", pcTrnsData);

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      PaperProps={{
        style: {
          width: 1650,
          minWidth: 1650,
          maxWidth: 1650,
        }
      }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={"เพิ่มการใช้เงิน"}
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1 }} >
          {pcTrnsData.PCTrnsId ?
            <BoxFR>
              <Typography variant="h6">เงินจ่าย :</Typography>
              <TextField {...textFieldProps('UsrNNm')} sx={{ width: 150 }} />
              <TextField {...textFieldProps('ExpNm')} />
              <TextField {...textFieldProps('Loc')}
                value={`${pcTrnsData.TakePlc || ""}-${pcTrnsData.Loc || ""}-${pcTrnsData.RtnPlc || ""}`} sx={{ flex: 1 }} />
              <TextField {...textFieldProps('PayAmnt')} {...bahtProps} sx={{ width: 150 }} />
              <TextField {...textFieldProps('DiffAmnt')} label="คงเหลือ" value={numberFormat(diffAmnt)} {...bahtProps} sx={{ width: 150 }} />
            </BoxFR>
            :
            <BoxFR>
              <ComboBox sx={{ width: 220 }} options={msData.accountAllCombo} label={pettyCashColNm.UsrNNm}
                selectedId={usrAccId}
                setSelectedId={(id) => setUsrAccId(id)}
              />
              <ComboBox sx={{ width: 150 }} options={msData.pcJournalCombo} label={pettyCashColNm.PCJnlId}
                selectedId={pcJnlId}
                setSelectedId={(id) => setPcJnlId(id)}
              />
            </BoxFR>
          }
          <Divider />
          <BoxFR>
            <BoxFC flex={1}>
              <BoxFR>
                <Typography variant="h6">การใช้เงิน</Typography>
                <ComboBox sx={{ width: 220 }} options={nonFavExp} label={"ค่าใช้จ่าย"}
                  selectedId={expId}
                  setSelectedId={(id) => setExpId(id)}
                />
                <Button variant="contained" onClick={handleAddFromCombo}><AddCircleRounded sx={{ mr: 1 }} /> เพิ่ม</Button>
              </BoxFR>
              <Box height={300} sx={{
                ...sxSumColorClass,
                "& .cost": { bgcolor: red[50] },
                "& .income": { bgcolor: green[50] },
                "& .select": { p: 0 },
                "& .MuiSelect-select.MuiInputBase-input": { pl: 1, pr: 1.5 },
                "& .MuiSelect-icon": { right: 0 }
              }}>
                <DataGridCellExpand
                  columnVisibilityModel={{ PCJnlId: pcTrnsData.PCTrnsId ? false : true }}
                  hideFooter
                  hideToolbar
                  rows={modDataTable}
                  columns={pcItemAddTableColumnsMemo}
                  onCellEditCommit={handleEditCommit}
                  getRowClassName={getSumColorClassName}
                  experimentalFeatures={{ rowPinning: true }}
                  pinnedRows={{ bottom: [modDataTable.find(row => row.id === 0)] }}
                />
              </Box>
            </BoxFC>
            <BoxFC sx={{ gap: 0 }}>
              <Typography fontWeight="bold">ค่าใช้จ่ายที่ใช้บ่อย</Typography>
              <Box p={0.5} width={200} bgcolor={blueGrey[50]} height={335} sx={{ overflow: "auto" }}>
                {favExp.map(exp => (
                  <Button key={exp.id} sx={{ p: 0, justifyContent: "flex-start" }} onClick={() => { handleAddExp(exp) }}>
                    <AddCircleRounded sx={{ mr: 1 }} />
                    <Box sx={{ width: 150, py: 0.5, textAlign: "left", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                      {exp.label}
                    </Box>
                  </Button>
                ))}
              </Box>
              <Typography variant="caption">(เพิ่มได้จาก ตั้งค่าส่วนตัว&gt;ตั้งค่าทั่วไป)</Typography>
            </BoxFC>
          </BoxFR>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={"เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(AddItemTableDialog)